import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/reservation-phase';

const phaseList = (merchantId, branchId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}`, data);
};

const addPhase = (merchantId, branchId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/${branchId}`, data);
};

const updatePhase = (merchantId, branchId, id, data) => {
	return Client.put(`${baseUrl}/${merchantId}/${branchId}/${id}`, data);
};

export default {
	phaseList,
	addPhase,
	updatePhase,
};
